// extracted by mini-css-extract-plugin
export default {"Label":"default-group-header-label-module__Label--yY28o","AggregateLabels":"default-group-header-label-module__AggregateLabels--TeNNp"};